<h2 mat-dialog-title>
  <mat-icon>autorenew</mat-icon>
  Consistir Lançamentos
</h2>

<mat-dialog-content>
  <p class="consistir-titulo">{{ titulo }}</p>

  <mat-progress-bar
    [mode]="running && progress === 0 ? 'indeterminate' : 'determinate'"
    [value]="progress * 100">
  </mat-progress-bar>

  <div class="consistir-log">
    <div class="consistir-log-line" *ngFor="let linha of log">{{ linha }}</div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button color="warn" (click)="cancelar()" [disabled]="!running || finished">
    Cancelar
  </button>
  <button mat-raised-button color="primary" (click)="fechar()" [disabled]="running && !finished">
    Fechar
  </button>
</mat-dialog-actions>
